module.exports = __webpack_public_path__ + "img/uploadvideo.935e526a.png";